<div class="base-modal">
    <span class="base-modal__close-button" (click)="closeModal()">
        <i class="material-icons"> close </i>
    </span>
    <div class="base-modal__header">
        <h2 class="base-modal__title">Widget connection</h2>
    </div>

    <form [formGroup]="widgetForm">
        <div class="base-modal__body">
            <div class="brn-form-field">
                <input type="text" formControlName="welcomeText" placeholder="Greetings text" />
            </div>
            <div class="brn-form-field">
                <input type="number" formControlName="showWelcomeDelay" placeholder="Sec delay" />
            </div>
            <div class="brn-form-field">
                <brn-form-select formControlName="position" [options]="positions" [suggest]="true"
                    [optionLabel]="'name'" placeholder="Position type">
                </brn-form-select>
            </div>

            <div class="widget-code">
                <span class="copy-to-clipboard" (click)="copyToClipboard()">
                    <i class="material-icons"> content_copy </i>
                </span>
                {{widgetCode}}
            </div>

            <div class="start-button">
                Start button
            </div>

            <div class="brn-form-field">
                <brn-form-checkbox formControlName="start_button">Activate</brn-form-checkbox>
            </div>


        </div>

        <div class="base-modal__footer">
            <!-- --------------------------- New connection ---------------------------- -->
            <ng-container *ngIf="newConnection">
                <button class="button button--flat" (click)="createConnection()"
                    [ngClass]="{ 'button--disabled': !validForm }">
                    Create connection
                    <i *ngIf="pendingStatus" class="material-icons button__loader">
                        rotate_right
                    </i>
                </button>
            </ng-container>
            <!-- --------------------------- Edit connection --------------------------- -->

            <ng-container *ngIf="!newConnection">
                <button class="button button--flat" (click)="updateConnection()"
                    [ngClass]="{ 'button--disabled': !validForm }">
                    Save changes
                    <i *ngIf="pendingStatus" class="material-icons button__loader">
                        rotate_right
                    </i>
                </button>
                <button class="button button--flat button--danger" (click)="removeConnection()">
                    Remove connection
                </button>
            </ng-container>
        </div>
    </form>
</div>